/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["Pirmadienis", "Antradienis", "Tre\u010Diadienis", "Ketvirtadienis", "Penktadienis", "\u0160e\u0161tadienis", "Sekmadienis"], e = ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegu\u017E\u0117", "Bir\u017Eelis", "Liepa", "Rugpj\u016Btis", "Rugs\u0117jis", "Spalis", "Lapkritis", "Gruodis"], i = "Met\u0173 pasirinkimas", s = "Metai", t = "M\u0117nesis", n = "Savait\u0117", d = "Diena", r = "\u0160iandien", k = "Joki\u0173 \u012Fvyki\u0173", o = "Visa diena", y = "I\u0161trinti", v = "Sukurti \u012Fvyk\u012F", M = "dddd, D MMMM YYYY", u = { weekDays: a, months: e, years: i, year: "Metai", month: "M\u0117nesis", week: "Savait\u0117", day: "Diena", today: "\u0160iandien", noEvent: "Joki\u0173 \u012Fvyki\u0173", allDay: "Visa diena", deleteEvent: "I\u0161trinti", createEvent: "Sukurti \u012Fvyk\u012F", dateFormat: "dddd, D MMMM YYYY" };
export {
  o as allDay,
  v as createEvent,
  M as dateFormat,
  d as day,
  u as default,
  y as deleteEvent,
  t as month,
  e as months,
  k as noEvent,
  r as today,
  n as week,
  a as weekDays,
  s as year,
  i as years
};
